var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "separable" }, [
    _c(
      "div",
      { staticClass: "marginTop container" },
      [
        _c(
          "el-row",
          [
            _c("el-col", { attrs: { span: 24 } }, [
              _c("div", { staticClass: "card" }, [
                _c("div", { staticClass: "card-header titulo" }, [
                  _vm._v("Processos existentes")
                ]),
                _c(
                  "div",
                  { staticClass: "marginDivider" },
                  [
                    _c("app-divider-refresh-button", {
                      attrs: {
                        label: _vm.headerLabel,
                        hasButton: _vm.hasRefreshButton,
                        content: _vm.tooltipRefreshButton,
                        showBorder: false
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "card-body" },
                  [
                    _c("el-row", [_c("div", { staticClass: "divider" })]),
                    _c(
                      "div",
                      { staticClass: "table-pointer" },
                      [
                        _c(
                          "el-table",
                          {
                            attrs: {
                              data: _vm.processos,
                              "default-sort": {
                                prop: "id",
                                order: "descending"
                              }
                            },
                            on: { "sort-change": _vm.sort }
                          },
                          [
                            !_vm.isBusca
                              ? _c("template", { slot: "empty" }, [
                                  _vm._v("Não há registros.")
                                ])
                              : _c("template", { slot: "empty" }, [
                                  _vm._v("Não há registros.")
                                ]),
                            _c("el-table-column", {
                              attrs: { "min-width": "40" },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c("div", { staticClass: "green" }, [
                                        _c("i", {
                                          staticClass: "fal fa-eye",
                                          staticStyle: {
                                            "{margin-left": "10px",
                                            cursor: "pointer"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.goTo(scope.row)
                                            }
                                          }
                                        })
                                      ])
                                    ]
                                  }
                                }
                              ])
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "numeroProcesso",
                                label: "Processo",
                                "min-width": "120"
                              }
                            }),
                            _c("el-table-column", {
                              attrs: {
                                label: "CPF/CNPJ do interessado",
                                "min-width": "195",
                                prop: "cpfCnpjInteressado",
                                formatter: _vm.formatCpfCnpj
                              }
                            }),
                            _c("el-table-column", {
                              attrs: {
                                label: "Nome/Razão social do interessado",
                                prop: "nomeRazaoSocialInteressado",
                                "min-width": "265",
                                sortable: "sortable"
                              }
                            }),
                            _c("el-table-column", {
                              attrs: {
                                label: "Tipo de processo",
                                prop: "tipo.nome",
                                sortable: "sortable",
                                "min-width": "130"
                              }
                            }),
                            _c("el-table-column", {
                              attrs: {
                                label: "Perfil do Vistoriador",
                                prop: "vistoriador",
                                "min-width": "130"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _vm._v(
                                        _vm._s(_vm.getNomePerfil(scope.row))
                                      )
                                    ]
                                  }
                                }
                              ])
                            }),
                            _c("el-table-column", {
                              attrs: {
                                label: "Ações",
                                align: "center",
                                "align-header": "center",
                                width: "100%"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c(
                                        "el-dropdown",
                                        {
                                          staticClass: "botao-acoes",
                                          attrs: {
                                            trigger: "click",
                                            size: "small"
                                          }
                                        },
                                        [
                                          _vm.showAcoes(scope.row)
                                            ? _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    type: "primary",
                                                    size: "mini"
                                                  }
                                                },
                                                [
                                                  _vm._v("Ações"),
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-arrow-down el-icon--right"
                                                  })
                                                ]
                                              )
                                            : _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    type: "primary",
                                                    size: "mini",
                                                    disabled: "disabled"
                                                  }
                                                },
                                                [
                                                  _vm._v("Ações"),
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-arrow-down el-icon--right"
                                                  })
                                                ]
                                              ),
                                          _c(
                                            "el-dropdown-menu",
                                            {
                                              attrs: { slot: "dropdown" },
                                              slot: "dropdown"
                                            },
                                            [
                                              !_vm.hasVistoriaFinalizada(
                                                scope.row
                                              )
                                                ? _c("div", [
                                                    scope.row.vistoriador
                                                      ? _c(
                                                          "div",
                                                          {
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.$emit(
                                                                  "alterar",
                                                                  scope.row
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "el-dropdown-item",
                                                              [
                                                                _c("i", {
                                                                  staticClass:
                                                                    "fas fa-user"
                                                                }),
                                                                _vm._v(
                                                                  "  Alterar credenciado"
                                                                )
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      : _c(
                                                          "div",
                                                          {
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.$emit(
                                                                  "vincular",
                                                                  scope.row
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "el-dropdown-item",
                                                              [
                                                                _c("i", {
                                                                  staticClass:
                                                                    "fas fa-user"
                                                                }),
                                                                _vm._v(
                                                                  "  Vincular credenciado"
                                                                )
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                  ])
                                                : _c(
                                                    "div",
                                                    [
                                                      _c(
                                                        "el-tooltip",
                                                        {
                                                          staticClass: "item",
                                                          attrs: {
                                                            effect: "dark",
                                                            content:
                                                              "Vistoria finalizada",
                                                            placement: "top"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "el-dropdown-item",
                                                            {
                                                              staticClass:
                                                                "disabled"
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "fas fa-user"
                                                              }),
                                                              _vm._v(
                                                                "  Alterar credenciado"
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  ),
                                              _c(
                                                "el-dropdown-item",
                                                {
                                                  nativeOn: {
                                                    click: function($event) {
                                                      return _vm.openModalHistorico(
                                                        scope.row
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fas fa-user"
                                                  }),
                                                  _vm._v("  Histórico")
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                }
                              ])
                            })
                          ],
                          2
                        )
                      ],
                      1
                    ),
                    _vm._t("default"),
                    [
                      _vm.openModal && _vm.numeroProcesso
                        ? _c("AppModalHistoricoVistoriadores", {
                            attrs: { numeroProcesso: _vm.numeroProcesso },
                            on: { closeModal: _vm.closeModal }
                          })
                        : _vm._e()
                    ]
                  ],
                  2
                )
              ])
            ])
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-df3026b0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-df3026b0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/central/credenciados/ListagemProcessosCredenciado.vue
// module id = null
// module chunks = 